import { render, staticRenderFns } from "./BalanceTab.vue?vue&type=template&id=1f4bd7dc&scoped=true"
import script from "./BalanceTab.vue?vue&type=script&lang=js"
export * from "./BalanceTab.vue?vue&type=script&lang=js"
import style0 from "./BalanceTab.vue?vue&type=style&index=0&id=1f4bd7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bd7dc",
  null
  
)

export default component.exports